'use client';
/* Built In Imports */
/* External Imports */
/* Internal Imports */
/* Components */
import ILA404 from '@app-ila/components/Layout/ILA404';
import { BUILD_TYPE_CONFIG } from '@utils/index';
import { useEffect, useState } from 'react';
// import * as Sentry from '@sentry/browser';
/* Services */
let nextBuildType = process?.env?.NEXT_PUBLIC_BUILDTYPE?.toUpperCase();
const { buildType } = BUILD_TYPE_CONFIG;
export default function Custom404({ region }) {
  const [blType, setBlType] = useState(nextBuildType);
  const [site, setSite] = useState('');
  useEffect(() => {
    setTimeout(() => {
      const paths = location?.pathname?.split('/');
      setSite(paths[1] || 'default');
    }, 0);
  }, []);
  if (!blType) return <main>Page not found</main>;
  return (
    <main>
      <ILA404></ILA404>
    </main>
  );
}
